// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let MediaCard = require("../../common/Components/MediaCard.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertySearchResultCard_propertyV5_graphql = require("../../../__generated__/PropertySearchResultCard_propertyV5_graphql.bs.js");

let getConnectionNodes = PropertySearchResultCard_propertyV5_graphql.Utils.getConnectionNodes;

let convertFragment = PropertySearchResultCard_propertyV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertySearchResultCard_propertyV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertySearchResultCard_propertyV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertySearchResultCard_propertyV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertySearchResultCard_propertyV5_graphql.node, convertFragment, fRef);
}

let PropertyFragment = {
  getConnectionNodes: getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertySearchResultCard(props) {
  let property = RescriptRelay_Fragment.useFragment(PropertySearchResultCard_propertyV5_graphql.node, convertFragment, props.property);
  let mainImage = getConnectionNodes(property.images)[0];
  return JsxRuntime.jsx(MediaCard.make, {
    topLeftLabels: props.label,
    mediaLink: `/properties/` + property.id,
    media: mainImage !== undefined ? ({
        TAG: "Image",
        _0: {
          src: mainImage.url,
          width: 648,
          height: 468,
          alt: ""
        }
      }) : ({
        TAG: "Icon",
        _0: "home"
      }),
    children: props.children
  });
}

let make = PropertySearchResultCard;

exports.PropertyFragment = PropertyFragment;
exports.make = make;
/* MediaCard Not a pure module */
